import {
  compareDateComponents,
  parseBirthDateComponents,
  toDateComponents,
} from '@/Pages/Signup/utils/age';

/**
 * Idade mínima para o ADICIONAL fazer o próprio onboarding (regra: mais que 16
 * anos). Abaixo disso a única via é o titular enviar a foto — a pessoa não faz
 * o desafio de vivacidade sozinha nem responde pelo próprio consentimento.
 * Espelha `COMPANION_SELF_ONBOARDING_MIN_AGE` do service; quem decide de fato é
 * ele (o cliente só usa isto para mostrar as opções certas).
 */
export const COMPANION_SELF_ONBOARDING_MIN_AGE = 17;

export function companionCanSelfOnboard(birthDate: string, referenceDate = new Date()): boolean {
  const birth = parseBirthDateComponents(birthDate);
  if (!birth) return false;
  const reference = toDateComponents(referenceDate);
  const cutoff = {
    year: reference.year - COMPANION_SELF_ONBOARDING_MIN_AGE,
    month: reference.month,
    day: reference.day,
  };
  return compareDateComponents(birth, cutoff) <= 0;
}

/**
 * Acompanhante que SABIDAMENTE tem 16 anos ou menos (data de nascimento
 * preenchida e abaixo do corte). Sem data não dá para afirmar nada — o service
 * também trata "sem data" como "não pode se cadastrar sozinho", mas a vaga sem
 * data pode ser de um adulto, então a UI não esconde o link nesse caso.
 */
export function isKnownMinorCompanion(
  birthDate: string | null,
  referenceDate = new Date(),
): boolean {
  if (birthDate === null || birthDate.trim() === '') return false;
  if (parseBirthDateComponents(birthDate) === null) return false;
  return !companionCanSelfOnboard(birthDate, referenceDate);
}
